module.exports = function () {
  return new Promise(function (resolve) {
    require.ensure([], function (require) {
      resolve(require("!!/Users/metabase/code/releases/release-2023-01-17/metabase-0.45.2/node_modules/babel-loader/lib/index.js??ruleSet[1].rules[0].use[0]!/Users/metabase/code/releases/release-2023-01-17/metabase-0.45.2/frontend/src/metabase-lib/metadata/utils/ga-metadata.js"));
    });
  });
}